<div class="w-full">
  <div class="hide" [ngClass]="{ show: suggestions.length > 0 }">
    <div class="">
      Sugerencias:
      <div class="flex gap-3 overflow-auto">
        @for (suggest of suggestions; track $index) {
        <p
          (click)="replaceWord(suggest)"
          class="cursor-pointer px-2 border rounded-xl"
        >
          {{ suggest }}
        </p>
        }
      </div>
    </div>
  </div>
  <label for="spell-input">Escribí algo:</label>
  <input
    id="spell-input"
    class="w-full rounded-none rounded-t-md focus:shadow-none p-2"
    type="text"
    [(ngModel)]="inputText"
    (ngModelChange)="onInputChange($event)"
    placeholder="Probá con palabras mal escritas..."
  />
</div>
